import { render, staticRenderFns } from "./deleteleadlogs.vue?vue&type=template&id=6ef3d40c"
import script from "./deleteleadlogs.vue?vue&type=script&lang=js"
export * from "./deleteleadlogs.vue?vue&type=script&lang=js"
import style0 from "./deleteleadlogs.vue?vue&type=style&index=0&id=6ef3d40c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports